export default __webpack_public_path__ + "static/media/about-iHunt.32604713.png";